module.exports = __webpack_public_path__ + "img/knight4_feature_01.b4e89bbc.jpg";